import React from 'react'
import { Link } from 'react-router-dom'
import notFound from '../../assets/4041.svg'

const NotFound = () => {
  return (
    <div className='noPageFoundMainContainer'>
      <img className='noPageFoundImage' src={notFound} alt="" aria-hidden="true" />
      <h1 className='noPageFoundText'>The requested page was not found. It seems you have ventured onto a broken link</h1>
      <Link to='/' className='noPageFoundBackButton'>
        Back to Home Page
      </Link>
    </div>
  )
}

export default NotFound